/**
 * There will be one reducer file per page / common component
 */
import {
    GET_FILTER_SEARCH_DATA,
    GET_FILTER_SEARCH_DATA_SUCCESS,
    GET_FILTER_SEARCH_DATA_FAILURE,
    SET_FILTER_DATA,
    CLEAR_SEARCH_FILTER,
} from 'src/pages/more/pages/templates/redux/action/actionTypes.js';

const initialState = {
    productTemplateRefinedFilters: {
        accountsRefineData: [],
        createdByRefineData: [],
        physiciansRefineData: [],
        procedureRefineData: [],
        templateOrderTypeRefineData: [],
    },
    productsTemplatesFilterError: '',
    productsTemplatesFilterLoading: false,
    productTemplatesSelectedFilter: {
        selectedAccount: [],
        selectedCreatedBy: [],
        selectedPhysician: [],
        selectedProcedure: [],
        selectedType: [],
    },
    // templateSubCategoryList: [],
    // expandedFilterView: {
    //     AccountView: true,
    //     PhysiciansView: false,
    //     ProcedureView: false,
    //     CreatedBy: false,
    // },
};

const compareValue = {
    account: 'accountId',
    physician: 'physicianId',
    createdBy: 'createdByCode',
    procedure: 'procedureId',
    orderType: 'orderTypeCode',
};

const updateList = (response, selectedData, filterType) => {
    let result = [...selectedData];
    response.map((data) => {
        // if (!selectedData.includes(data)) {
        //     result.push(data);
        // }
        if (
            !selectedData.some(
                (selectedValue) =>
                    selectedValue[compareValue[filterType]] ===
                    data[compareValue[filterType]]
            )
        ) {
            result.push(data);
        }
    });
    return result;
};

const filterSearchReducer = (state = initialState, action) => {
    switch (action.type) {
        // case SET_PRODUCT_TEMPLATE_REFINE_DATA:
        //     return {
        //         ...state,
        //         productTemplateRefinedFilters: action.payload,
        //     };
        // case SET_PRODUCTSTEMPLATESFILTER:
        //     return {
        //         ...state,
        //         productTemplatesSelectedFilter: action.payload,
        //     };
        // case GET_PRODUCTSTEMPLATESFILTER:
        //     return {
        //         ...state,
        //         productsTemplatesFilterLoading: true,
        //     };
        // case GET_PRODUCTSTEMPLATESFILTER_SUCCESS:
        //     return {
        //         ...state,
        //         productTemplateRefinedFilters:
        //             action.productTemplateRefinedFilters,
        //         productsTemplatesFilterError: '',
        //         productsTemplatesFilterLoading: false,
        //     };
        // case GET_PRODUCTSTEMPLATESFILTER_FAILURE:
        //     return {
        //         ...state,
        //         productTemplateRefinedFilters: [],
        //         productsTemplatesFilterError: action.templateError,
        //         productsTemplatesFilterLoading: false,
        //     };
        // case SET_PRODCUCT_TEMPLATE_SUB_CATEGORY_LIST:
        //     return {
        //         ...state,
        //         templateSubCategoryList: action.payload,
        //     };
        // case SET_EXPANDED_FILTER_VIEW:
        //     return {
        //         ...state,
        //         expandedFilterView: action.payload,
        //     };
        case GET_FILTER_SEARCH_DATA:
            return {
                ...state,
                productsTemplatesFilterLoading: true,
            };
        case GET_FILTER_SEARCH_DATA_SUCCESS:
            return {
                ...state,
                productTemplateRefinedFilters: {
                    accountsRefineData: action.payload.accountsRefineData
                        ? updateList(
                              action.payload.accountsRefineData,
                              state.productTemplatesSelectedFilter
                                  .selectedAccount,
                                 'account'
                          )
                        : state.productTemplatesSelectedFilter.selectedAccount,
                    createdByRefineData: action.payload.createdByRefineData
                        ? updateList(
                              action.payload.createdByRefineData,
                              state.productTemplatesSelectedFilter
                                  .selectedCreatedBy,
                                  'createdBy'
                          )
                        : state.productTemplatesSelectedFilter
                              .selectedCreatedBy,
                    physiciansRefineData: action.payload.physiciansRefineData
                        ? updateList(
                              action.payload.physiciansRefineData,
                              state.productTemplatesSelectedFilter
                                  .selectedPhysician,
                                  'physician'
                          )
                        : state.productTemplatesSelectedFilter
                              .selectedPhysician,
                    procedureRefineData: action.payload.procedureRefineData
                        ? updateList(
                              action.payload.procedureRefineData,
                              state.productTemplatesSelectedFilter
                                  .selectedProcedure,
                                  'procedure'
                          )
                        : state.productTemplatesSelectedFilter
                              .selectedProcedure,
                    templateOrderTypeRefineData: action.payload
                        .templateOrderTypeRefineData
                        ? updateList(
                              action.payload.templateOrderTypeRefineData,
                              state.productTemplatesSelectedFilter.selectedType,
                              'orderType'
                          )
                        : state.productTemplatesSelectedFilter.selectedType,
                    // templateOrderTypeRefineData:
                    //     state.productTemplatesSelectedFilter.selectedType
                    //         .length > 0
                    //         ? state.productTemplatesSelectedFilter.selectedType
                    //         : action.payload.templateOrderTypeRefineData,
                },
                productsTemplatesFilterError: '',
                productsTemplatesFilterLoading: false,
            };
        case GET_FILTER_SEARCH_DATA_FAILURE:
            return {
                ...state,
                productTemplateRefinedFilters: {
                    accountsRefineData: [],
                    createdByRefineData: [],
                    physiciansRefineData: [],
                    procedureRefineData: [],
                    templateOrderTypeRefineData: [],
                },
                productsTemplatesFilterError: action.templateError,
                productsTemplatesFilterLoading: false,
            };
        case SET_FILTER_DATA:
            return {
                ...state,
                productTemplatesSelectedFilter: {
                    selectedAccount:
                        action.payload.filterType === 'accountFilters'
                            ? action.payload.filters
                            : state.productTemplatesSelectedFilter
                                  .selectedAccount,
                    selectedCreatedBy:
                        action.payload.filterType === 'createdByFilters'
                            ? action.payload.filters
                            : state.productTemplatesSelectedFilter
                                  .selectedCreatedBy,
                    selectedPhysician:
                        action.payload.filterType === 'physicianFilters'
                            ? action.payload.filters
                            : state.productTemplatesSelectedFilter
                                  .selectedPhysician,
                    selectedProcedure:
                        action.payload.filterType === 'procedureFilters'
                            ? action.payload.filters
                            : state.productTemplatesSelectedFilter
                                  .selectedProcedure,
                    selectedType:
                        action.payload.filterType === 'typeFilters'
                            ? action.payload.filters
                            : state.productTemplatesSelectedFilter.selectedType,
                },
            };
        case CLEAR_SEARCH_FILTER:
            return {
                ...state,
                ...initialState,
                productTemplateRefinedFilters: {
                    templateOrderTypeRefineData:
                        state.productTemplateRefinedFilters.templateOrderTypeRefineData.map(
                            (data) => {
                                if (data.isChecked && data.name != 'All') {
                                    data.isChecked = false;
                                }
                                return data;
                            }
                        ),
                },
            };
        default: {
            return { ...state };
        }
    }
};

export default filterSearchReducer;
